<div class="signup-container">
  <!-- Left Section (same as signup) -->
  <div class="left-section">
    <div class="mannino-logo">
      <img
        src="../../assets/NEXGEN Logo final for footer.png"
        alt="NexGen Executive Coaching Academy Logo"
        routerLink="/home"
      />
    </div>

    <div class="progress-message">
      <h1>Yes! we're making progress!</h1>
      <p>every minute & every second</p>
    </div>

    <div class="main-content-block">
     <iframe
    *ngIf="videoUrl"
    [src]="videoUrl"
    class="video-placeholder"
    width="100%"
    height="100%"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>
    </div>

    <div class="bottom-message">
      <p>
        Begin your learning journey today and experience the transformative
        power of personalized education.
      </p>
    </div>
  </div>

  <!-- Right Section -->
  <div class="right-section">
    <div class="signup-content">
      <h1 class="create-account-text">Enter Confirmation Code</h1>
      <p class="community-text">We sent a code to <strong>{{ email }}</strong></p>

      <form (ngSubmit)="onConfirmCode()">
        <div class="form-group">
          <label for="code">Confirmation Code <span class="required">*</span></label>
          <input type="text" id="code" [(ngModel)]="code" name="code" placeholder="Enter code" required #codeInput="ngModel">
          <div *ngIf="codeInput.invalid && (codeInput.dirty || codeInput.touched || submitted)" class="error-message">
            Confirmation code is required.
          </div>
        </div>

        <button type="submit" class="register-button">Verify & Login</button>
      </form>

      <p class="already-have-account">
        Didn’t receive the code? <a (click)="resendCode()" class="signin-link">Resend Code</a>
      </p>
            <p class="dont-have-account"> <a routerLink="/signup" class="signup-link">Go Back</a></p>
    </div>

  </div>
</div>
